import { Localization } from "material-table";

export const LocalizationPTBr: Localization = {
    body: {
        emptyDataSourceMessage: "Nenhum registro encontrado",
        deleteTooltip: "Remover",
        editTooltip: "Editar",
        editRow: {
            saveTooltip: "Sim",
            cancelTooltip: "Cancelar",
            deleteText: "Você tem certeza que deseja remover esse item?",
        },
    },
    header: {
        actions: "Ações",
    },
    pagination: {
        labelDisplayedRows: "{from}-{to} de {count}",
        labelRowsSelect: "linhas",
        labelRowsPerPage: "Linhas por página",
        firstAriaLabel: "Primeira página",
        firstTooltip: "Primeira página",
        lastAriaLabel: "Última página",
        lastTooltip: "Última página",
        previousTooltip: "Página anterior",
        previousAriaLabel: "Página anterior",
        nextTooltip: "Próxima página",
        nextAriaLabel: "Próxima página",
    },
};
